import { Navigate, Outlet, useLocation } from "react-router-dom";
import { pathRoute } from "./PathRoute";
import { useSelector } from "react-redux";
import { tokenSelector } from "../redux/slices/userSlice";

function PrivateRoute() {
  const location = useLocation();
  const token = useSelector(tokenSelector);
  const isAuthenticated = Boolean(token);


  if (!isAuthenticated) {
    return (
      <Navigate to={pathRoute.auth.login} state={{ from: location }} replace />
    );
  }

  return <Outlet />;
}

export default PrivateRoute;
